import * as Types from 'src/actions/investor-type/update/Types';
import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { RootState } from 'src/reducers/RootReducer';
import { ActionCreator, Dispatch } from 'react-redux';
import ApiClient from 'src/services/api-client/ApiClient';
import { AxiosResponse } from 'axios';
import InvestorType from 'src/entities/InvestorType';
import ValidatorService from 'src/services/validation/Validation.service';

export interface UpdateInvestorTypeAttempt extends Action {
  type: Types.UPDATE_INVESTOR_TYPE_ATTEMPT;
}

export interface UpdateInvestorTypeSuccess extends Action {
  type: Types.UPDATE_INVESTOR_TYPE_SUCCESS;
}

export interface UpdateInvestorTypeFailure extends Action {
  type: Types.UPDATE_INVESTOR_TYPE_FAILURE;
  payload: {};
}

export type UpdateInvestorTypeAction =
  UpdateInvestorTypeAttempt |
  UpdateInvestorTypeSuccess |
  UpdateInvestorTypeFailure;

export interface UpdateInvestorTypeThunk extends
  ThunkAction<Promise<UpdateInvestorTypeAction>, RootState, null> { }

export const updateInvestorTypeAttempt: ActionCreator<UpdateInvestorTypeAttempt> = () => (
  { type: Types.UPDATE_INVESTOR_TYPE_ATTEMPT }
);

export const updateInvestorTypeSuccess: ActionCreator<UpdateInvestorTypeSuccess> = () => (
  {
    type: Types.UPDATE_INVESTOR_TYPE_SUCCESS,
  }
);

export const updateInvestorTypeFailure: ActionCreator<UpdateInvestorTypeFailure> =
  (error: {}) => (
    {
      type: Types.UPDATE_INVESTOR_TYPE_FAILURE,
      payload: error
    }
  );

export const updateInvestorType: ActionCreator<UpdateInvestorTypeThunk> = (
  personId: number,  personType: string, investorType: InvestorType
): UpdateInvestorTypeThunk => {

  return (dispatch: Dispatch<RootState>): Promise<UpdateInvestorTypeAction> => {

    dispatch(updateInvestorTypeAttempt());

    return ApiClient.investorType.update(personId, investorType, { personType: personType})
      .then((response: AxiosResponse): UpdateInvestorTypeSuccess => {
        return dispatch(updateInvestorTypeSuccess());
      }).catch((e: { response: { data: { error: {} } } }): UpdateInvestorTypeFailure => {
        const errorMessages = ValidatorService
          .translateValidations(e && e.response && e.response.data && e.response.data.error);

        return dispatch(updateInvestorTypeFailure(errorMessages));
      });
  };
};



// WEBPACK FOOTER //
// ./src/actions/investor-type/update/UpdateInvestorType.actions.tsx